import { render } from "./PhysicalNetworksTab.vue?vue&type=template&id=2ac6bb38&scoped=true"
import script from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"
export * from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"

import "./PhysicalNetworksTab.vue?vue&type=style&index=0&id=2ac6bb38&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac6bb38"]])

export default __exports__